import { render, staticRenderFns } from "./DataReportEarnedDetailStatistics.vue?vue&type=template&id=4a32066e&scoped=true"
import script from "./DataReportEarnedDetailStatistics.vue?vue&type=script&lang=js"
export * from "./DataReportEarnedDetailStatistics.vue?vue&type=script&lang=js"
import style0 from "./DataReportEarnedDetailStatistics.vue?vue&type=style&index=0&id=4a32066e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a32066e",
  null
  
)

export default component.exports